const NOTES_MAX_LENGTH = 100;
const NOTES_WARNING_THRESHOLD = 60;

/**
 * Returns a color string based on the current character count relative to the max allowed.
 * - Green when the user starts typing (1 to warning threshold)
 * - Orange when approaching the limit (warning threshold to max - 1)
 * - Red when the limit is reached (max)
 * - Muted when empty (0)
 */
export const getNotesCounterColor = (length = 0) => {
    if (length >= NOTES_MAX_LENGTH) return '#f44336';
    if (length >= NOTES_WARNING_THRESHOLD) return '#ff9800';
    if (length >= 1) return '#4caf50';
    return 'rgba(255, 255, 255, 0.5)';
};

export { NOTES_MAX_LENGTH };
